import { useEffect, useRef } from 'react'

import { useWebSocketContext } from '../WebSocketContext'
import type {
  WebSocketMessage,
  WebSocketMessageHandler,
  WebSocketMessageMatcher,
} from '../core/types'

export type UseWebSocketMessageOptions = {
  enabled?: boolean
}

export const useWebSocketMessage = (
  typeOrPredicate: WebSocketMessageMatcher,
  handler: WebSocketMessageHandler,
  options: UseWebSocketMessageOptions = {}
): void => {
  const { subscribeMessage } = useWebSocketContext()
  const handlerRef = useRef(handler)
  const enabled = options.enabled ?? true

  useEffect(() => {
    handlerRef.current = handler
  }, [handler])

  useEffect(() => {
    if (!enabled) return

    return subscribeMessage(typeOrPredicate, (message: WebSocketMessage) => {
      handlerRef.current(message)
    })
  }, [enabled, subscribeMessage, typeOrPredicate])
}
